import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-dial-number-1",
  "use": "icon-si-glyph-dial-number-1-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-dial-number-1\" id=\"icon-si-glyph-dial-number-1\"><title>1208</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><circle cx=\"2\" cy=\"3\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"7\" cy=\"3\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"13\" cy=\"2\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"2\" cy=\"8\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"7\" cy=\"8\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"12\" cy=\"8\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"2\" cy=\"13\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"7\" cy=\"13\" r=\"2\" class=\"si-glyph-fill\" /><circle cx=\"12\" cy=\"13\" r=\"2\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-dial-number-1.svg
// module id = Csdh
// module chunks = 62